var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import EstablishmentOptionNfcSettings from "./EstablishmentOptionNfcSettings";
import EstablishmentOptionGTM from "./EstablishmentOptionGTM";
import EstablishmentOptionTermsOfUse from "./EstablishmentOptionTermsOfUse";
import EstablishmentOptionEmailing from "./EstablishmentOptionEmailing";
import EstablishmentOptionReceipt from "./EstablishmentOptionReceipt";
import EstablishmentOptionVisualIdentity from "./EstablishmentOptionVisualIdentity";
import EstablishmentOptionMetadataNames from "./EstablishmentOptionMetadataNames";
var EstablishmentOption = /** @class */ (function (_super) {
    __extends(EstablishmentOption, _super);
    function EstablishmentOption(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.cashStatement = false;
        _this.cartPurchaseStatusUid = null;
        _this.paymentSuccessPurchaseStatusUid = null;
        _this.paymentErrorPurchaseStatusUid = null;
        _this.cancelPurchaseStatusUids = [];
        _this.switchlyPaymentMethodUid = null;
        _this.anonymousOrderPaymentMethodUid = null;
        _this.automaticStatusUids = [];
        _this.mdmClientUid = null;
        _this.onlinePaymentMethods = [];
        _this.posPaymentMethods = [];
        _this.nfcSettings = new EstablishmentOptionNfcSettings();
        _this.enablePosClientScreen = false;
        _this.disableInvoicing = false;
        _this.remainingStockThreshold = null;
        _this.manualBadgingLocationManagement = false;
        _this.receipt = new EstablishmentOptionReceipt();
        _this.gtm = new EstablishmentOptionGTM();
        _this.termsOfUse = [];
        _this.emailing = new EstablishmentOptionEmailing();
        _this.visualIdentity = new EstablishmentOptionVisualIdentity();
        _this.metadataNames = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        EstablishmentOption.buildFromJson(_this, obj);
        return _this;
    }
    EstablishmentOption.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'nfcSettings') {
                        instance[prop] = new EstablishmentOptionNfcSettings(json[prop]);
                    }
                    else if (prop === 'gtm') {
                        instance[prop] = new EstablishmentOptionGTM(json[prop]);
                    }
                    else if (prop === 'receipt') {
                        instance[prop] = new EstablishmentOptionReceipt(json[prop]);
                    }
                    else if (prop === 'termsOfUse') {
                        instance[prop] = [];
                        for (var subProp in json[prop]) {
                            instance[prop].push(new EstablishmentOptionTermsOfUse(json[prop][subProp]));
                        }
                    }
                    else if (prop === 'emailing') {
                        instance[prop] = new EstablishmentOptionEmailing(json[prop]);
                    }
                    else if (prop === 'visualIdentity') {
                        instance[prop] = new EstablishmentOptionVisualIdentity(json[prop]);
                    }
                    else if (prop === 'metadataNames') {
                        instance[prop] = [];
                        for (var subProp in json[prop]) {
                            instance[prop].push(new EstablishmentOptionMetadataNames(json[prop][subProp]));
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    EstablishmentOption.prototype.exportToJson = function () {
        var JSONEstablishmentOption = {};
        JSONEstablishmentOption.cashStatement = this.cashStatement;
        JSONEstablishmentOption.cartPurchaseStatusUid = this.cartPurchaseStatusUid;
        JSONEstablishmentOption.cancelPurchaseStatusUids = this.cancelPurchaseStatusUids;
        JSONEstablishmentOption.switchlyPaymentMethodUid = this.switchlyPaymentMethodUid;
        JSONEstablishmentOption.anonymousOrderPaymentMethodUid = this.anonymousOrderPaymentMethodUid;
        JSONEstablishmentOption.automaticStatusUids = this.automaticStatusUids;
        JSONEstablishmentOption.mdmClientUid = this.mdmClientUid;
        JSONEstablishmentOption.onlinePaymentMethods = this.onlinePaymentMethods;
        JSONEstablishmentOption.posPaymentMethods = this.posPaymentMethods;
        JSONEstablishmentOption.nfcSettings = this.nfcSettings;
        JSONEstablishmentOption.enablePosClientScreen = this.enablePosClientScreen;
        JSONEstablishmentOption.paymentSuccessPurchaseStatusUid = this.paymentSuccessPurchaseStatusUid;
        JSONEstablishmentOption.paymentErrorPurchaseStatusUid = this.paymentErrorPurchaseStatusUid;
        JSONEstablishmentOption.disableInvoicing = this.disableInvoicing;
        JSONEstablishmentOption.remainingStockThreshold = this.remainingStockThreshold;
        JSONEstablishmentOption.manualBadgingLocationManagement = this.manualBadgingLocationManagement;
        JSONEstablishmentOption.gtm = this.gtm.exportToJson();
        JSONEstablishmentOption.receipt = this.receipt.exportToJson();
        JSONEstablishmentOption.termsOfUse = [];
        for (var _i = 0, _a = this.termsOfUse; _i < _a.length; _i++) {
            var termsOfUse = _a[_i];
            JSONEstablishmentOption.termsOfUse.push(termsOfUse.exportToJson());
        }
        JSONEstablishmentOption.emailing = this.emailing.exportToJson();
        JSONEstablishmentOption.visualIdentity = this.visualIdentity.exportToJson();
        JSONEstablishmentOption.metadataNames = [];
        for (var _b = 0, _c = this.metadataNames; _b < _c.length; _b++) {
            var metadataName = _c[_b];
            JSONEstablishmentOption.metadataNames.push(metadataName.exportToJson());
        }
        return JSONEstablishmentOption;
    };
    return EstablishmentOption;
}(Model));
export default EstablishmentOption;
//# sourceMappingURL=EstablishmentOption.js.map